import React, { useContext, useEffect, useState } from "react";
import ActividadesProy from "./ActividadesProy";
import Estado3dim from "./Estado3dim";
import EarnValue from "./EarnValue";
import { AppContext } from "./index";
import ampliar from "./img/ampliar.png";
import ampliarR from "./img/ampliarR.png";
import { bkSubMain, borderSubMain, clBasic } from "./general";

export default function TableroProyecto() {
  // revisar para que cuando venga del menu se inicialice en null el proyectoActivo
  let { usrLogged, firebase } = useContext(AppContext);

  const [lmax, setLmax] = useState(0);
  const [ampliado, setAmpliado] = useState(false); // indica si la seccion de actividades se muestra ampliada

  useEffect(() => {
    if (usrLogged.isLogged || true) {
      document.getElementById("htmlTituloPagS").innerHTML = "Estado general"
      document.getElementById("dataProyecto").style.display = ampliado ? "none" : "flex";
      if (ampliado) {
        if (firebase.proyectoActivo.proyecto.tipo === "Agil") {
          setLmax(window.innerWidth * 0.59)
        } else setLmax(window.innerWidth * 0.62)
      } else {
        if (firebase.proyectoActivo.proyecto.tipo === "Agil") {
          setLmax(window.innerWidth * 0.25)
        } else setLmax(window.innerWidth * 0.28)
      }
    }
  }, [ampliado, usrLogged.isLogged]);

  if (usrLogged.isLogged || true)
    return (
      <div style={Sproyecto}>
        <div id="dataProyecto" style={SdataProyecto}>
          <div style={Striangulo}>
            <Estado3dim lado={window.innerWidth / 6.2} />
          </div>
          <div style={SearnV}>
            <EarnValue />
          </div>
        </div>

        <div style={Stimeline}>
          <img
            src={ampliado ? ampliarR : ampliar}
            alt="?"
            style={Sampliar}
            onClick={(e) => {
              setAmpliado(!ampliado);
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.background = "#424242";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.background = "";
            }}
          ></img>
          <ActividadesProy lmax={lmax} ampliado={ampliado} />
        </div>
      </div>
    );
  else return <div style={{ color: clBasic }}>Debe loguearse, gil!!</div>;
}

const Sampliar = {
  position: "absolute",
  height: "18px",
  width: "18px",
  zIndex: 10,
};

const Sproyecto = {
  fontSize: "2vh",
  height: "90vh",
  width: "91.5vw",
  display: "flex",
  flexDirection: "row",
  justifyContent: "space-evenly",
  margin: "15px",
};

const SdataProyecto = {
  display: "flex",
  flexDirection: "column",
  width: "37vw",
  height: "100%",
  overflow: "hidden",
};

const Striangulo = {
  height: "41vh",
  background: bkSubMain,
  border: `2px solid ${borderSubMain}`,
  borderRadius: "10px",
  padding: "20px",
  marginBottom: "20px"
};
const SearnV = {
  height: "41vh",
  background: bkSubMain,
  border: `2px solid ${borderSubMain}`,
  borderRadius: "10px",
  padding: "20px"
};

const Stimeline = {
  position: "relative",
  minWidth: "50vw",
  height: "100%",
  overflow: "hidden",
};
